import { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const AddBookingSidepanelPage = lazy(
  () => import('modules/space_control/pages/AddBookingSidepanelPage')
)
const BookingsPage = lazy(() => import('modules/space_control/pages/BookingsPage'))
const EditBookingSidepanelPage = lazy(
  () => import('modules/space_control/pages/EditBookingSidepanelPage')
)
const OverviewPage = lazy(() => import('modules/space_control/pages/OverviewPage'))
const RedirectToSpacesOverviewPage = lazy(
  () => import('modules/space_control/pages/RedirectToSpaceOverviewPage')
)
const RootPage = lazy(() => import('modules/space_control/pages/RootPage'))

export const spaceControlRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.spaceControl.path,
    element: <RootPage />,
    handle: {
      module: 'space_control',
      meta: () => ({
        title: i18n.t('sidebar.space_control'),
        settings: navigation.settings.locations.fullPath(),
        subNavigation: [
          {
            title: i18n.t('space_control.overview.tab'),
            href: navigation.spaceControl.overview.fullPath(),
            index: true,
          },
          {
            title: i18n.t('space_control.my-bookings.tab'),
            href: navigation.spaceControl.bookings.fullPath(),
          },
        ],
      }),
    },
    children: [
      {
        index: true,
        element: <RedirectToSpacesOverviewPage />,
      },
      {
        path: navigation.spaceControl.overview.path,
        element: <OverviewPage />,
        children: [
          {
            path: navigation.spaceControl.overview.booking.path,
            element: <AddBookingSidepanelPage />,
          },
        ],
      },
      {
        path: navigation.spaceControl.bookings.path,
        element: <BookingsPage />,
        children: [
          {
            path: navigation.spaceControl.bookings.edit.path,
            element: <EditBookingSidepanelPage />,
          },
        ],
      },
    ],
  },
]
